export const statsConfig = {
  uae: {
    stats: [
      { 
        icon: "staticsection_1.svg", 
        value: "2M+",
        id: "users"
      },
           { 
        icon: "staticsection_2.svg", 
        value: "700+",
        id: "franchise"
      },
         { 
        icon: "timer.png", 
        value: "24/7",
        id: "support"
      }
    ]
  }
};